export {
    JiraServiceManagementSoftwarePageTemplate,
    LandingBannerAlert
} from "./jira-service-management-software-page.template";
export { JiraServiceManagementSoftwarePageTemplate as default } from "./jira-service-management-software-page.template";
